import { render, staticRenderFns } from "./RbuItem.vue?vue&type=template&id=3bb0fe27&scoped=true"
import script from "./RbuItem.vue?vue&type=script&lang=js"
export * from "./RbuItem.vue?vue&type=script&lang=js"
import style0 from "./RbuItem.vue?vue&type=style&index=0&id=3bb0fe27&prod&lang=less"
import style1 from "./RbuItem.vue?vue&type=style&index=1&id=3bb0fe27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb0fe27",
  null
  
)

export default component.exports